import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./ContentContainer.module.scss";
const ContentListTag = ({ contentList, selectedTag, setSelectedTag }) => {
  const navigate = useNavigate();
  const handleChange = (tag) => {
    setSelectedTag(tag);
    navigate(tag.path);
  };
  return (
    <div className={styles["content-list-tags"]}>
      {contentList.map((item, index) => {
        return (
          <Tag.CheckableTag
            key={index}
            checked={selectedTag?.label == item.label}
            onChange={() => handleChange(item)}
          >
            {item.label}
          </Tag.CheckableTag>
        );
      })}
    </div>
  );
};

export default ContentListTag;
